import { lazy, Suspense } from 'react';

const HpRespRecentlyViewedItems = lazy(() =>
    import(/* webpackChunkName: "HpRespRecentlyViewedItems" */ './HpRespRecentlyViewedItems')
);

export function HpRespRecentlyViewedItemsLoader(props) {
    return (
        <Suspense fallback={null}>
            <HpRespRecentlyViewedItems {...props} />
        </Suspense>
    );
}
